
























































































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
@Component({})
export default class IdrTongueBiduiPicControl extends Vue {
  @Prop()
  private tongues: any;
  private pics: any[] = [
    { current: "" },
    { current: "" },
    { current: "" },
    { current: "" }
  ];
  /**
   * @description 改变显示的图片
   */
  private changeShowPic(index, src) {
    this.pics[index]["current"] = src;
    this.$forceUpdate();
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.pics = _.cloneDeep(this.tongues);
    this.pics.map((pic: any) => {
      pic.current = pic["舌象照片"]["分割后图片"];
    });
  }
}
